export const LightMode = {
    light: "light",
    dark: "dark"
}

export const ColorMode = {
    pink: "pink",
    blue: "blue",
}

export function getNextColor(currentColorMode) {
    switch (currentColorMode) {
        case ColorMode.pink:
            return ColorMode.blue;
        case ColorMode.blue:
            return ColorMode.pink;
        default:
            return ColorMode.pink;
    }
}
